import {SUBSCRIBE_DONOR_LIST_F, SUBSCRIBE_DONOR_LIST_S, SUBSCRIBE_ONETIMEDONOR_LIST_F, SUBSCRIBE_ONETIMEDONOR_LIST_S } from "../constants/types";

const initialState = {
    subscribedonorlist:[],
    onetimesubscribdodnor: []
    };

const SubscribeDonorReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUBSCRIBE_DONOR_LIST_S:
            return {
                ...state, subscribedonorlist: action.payload.data
            }
        case SUBSCRIBE_DONOR_LIST_F:
            return {
                ...state, subscribedonorlist: action.payload.message
            }
            case SUBSCRIBE_ONETIMEDONOR_LIST_S:
            return {
                ...state, onetimesubscribdodnor: action.payload.data
            }
        case SUBSCRIBE_ONETIMEDONOR_LIST_F:
            return {
                ...state, onetimesubscribdodnor: action.payload.message
            }
        default:
            return state;
    }
}
export default SubscribeDonorReducer